angular.module("update")

    .controller("UpdateListCtrl", ['$rootScope', '$scope', 'UpdateService', '$filter', function ($rootScope, $scope, UpdateService, $filter) {
        
        $rootScope.title = $filter('translate')('update.title');
        $rootScope.breadcrumb = [
            { title: $filter('translate')('update.new_version') }
        ];

        $scope.version = UpdateService.version;
        $rootScope.$watch("version", function () {
            $scope.version = UpdateService.version;
            if (!$scope.$$phase) $scope.$apply();
        });

        $scope.update = function () {
            UpdateService.update()
        };

        $scope.download = function () {
            UpdateService.download()
        };
        
    }])

;